<template>
    <v-container fluid id="achievements">
        <div id="content">
            <h1>{{ $t('homepage.achievements.title') }}</h1>
            <div class="pb-5" id="timeline">
                <TimelineComponent :dark="true" :items="timelineItems"/>
            </div>
        </div>
    </v-container>
</template>

<script>
    import TimelineComponent from '@/components/common/TimelineComponent'
    import achievements from '@/achievements.js'

    export default {
        name: "AchievementsComponent",
        components: {
            TimelineComponent
        },
        data() {
            return {
                timelineItems: achievements
            }
        }
    }
</script>

<style lang="sass" scoped>
    #achievements
        height: 100vh
        margin: 0
        position: relative
        padding: 0
        background: linear-gradient(1.39deg, #110C47 5.77%, rgba(17, 12, 71, 0) 31.58%), linear-gradient(0deg, rgba(30, 24, 98, 0.41), rgba(30, 24, 98, 0.41)), linear-gradient(0deg, rgba(17, 12, 71, .7), rgba(17, 12, 71, .7)), url('../../assets/img/components/achievements/background.webp') center fixed
        background-size: cover

        #content
            height: 100%
            display: -webkit-flex
            display: flex
            -webkit-flex-direction: column
            flex-direction: column

            h1
                padding: 70px 0 50px 0
                font-family: Inter, serif
                font-style: normal
                font-weight: bold
                font-size: 2em
                line-height: 75px
                text-align: center
                color: #FFFFFF

            #timeline
                -webkit-flex: 1 1 auto
                overflow-y: scroll

                &::-webkit-scrollbar
                    width: 5px

                &::-webkit-scrollbar-track
                    border-radius: 10px

                &::-webkit-scrollbar-thumb
                    border-radius: 10px
                    background: rgba(255, 255, 255, .2)

                &::-webkit-scrollbar-thumb:hover
                    background: rgba(255, 255, 255, .5)

</style>
